import React, { FC, useEffect, useState } from 'react';

import { TagCondition } from '@ariksa/compliance-policies';
import { Box, Wrap, WrapItem, Stack } from '@chakra-ui/react';
import { map, find, filter, includes } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';

import { Tag } from 'components/DataDisplay';
import { Select } from 'components/DataEntry';
import { selectSharedState } from 'containers/SharedState/selectors';
import { actions as sharedStateActions } from 'containers/SharedState/slice';

import { useEnvironmentContext } from '../../../../../context';
import { selectEnvironment } from '../../../../../selectors';
import { actions } from '../../../../../slice';
import { tagQuantifierOptions } from '../../../../../utils';

interface Props {
  id: string;
}

export const TagKeyValueComponent: FC<Props> = props => {
  const { id } = props;
  const { tagKeyOptions } = useEnvironmentContext();
  const { tagKeyValueCriteria } = useSelector(selectEnvironment);
  const { tagValues } = useSelector(selectSharedState);
  const { tagKeys } = useSelector(selectSharedState);
  const [valueOptions, setValueOptions] = useState<Record<string, any>[]>([]);
  const [selectedKey, setSelectedKey] = useState<Record<string, any>>({});
  const [selectedKeyCondition, setSelectedKeyCondition] = useState<
    Record<string, any>
  >(tagQuantifierOptions[0]);
  const [selectedValueCondition, setSelectedValueCondition] = useState<
    Record<string, any>
  >(tagQuantifierOptions[0]);
  const [selectedValues, setSelectedValues] = useState<Record<string, any>[]>(
    [],
  );
  const dispatch = useDispatch();

  //set initial values
  useEffect(() => {
    setSelectedKey(
      find(tagKeyOptions, o => o?.value === tagKeyValueCriteria[id]?.key) ||
        tagKeyOptions[0],
    );
    /*setSelectedKeyCondition(
      tagKeyValueCriteria[id]?.key_condition === TagCondition.Is
        ? tagQuantifierOptions[0]
        : tagQuantifierOptions[1],
    );
    setSelectedValueCondition(
      tagKeyValueCriteria[id]?.value_condition === TagCondition.Is
        ? tagQuantifierOptions[0]
        : tagQuantifierOptions[1],
    );*/
    setSelectedValues(
      filter(valueOptions, o =>
        includes(tagKeyValueCriteria[id]?.value, o?.value),
      ),
    );
  }, [tagKeyOptions, tagKeyValueCriteria, id, valueOptions]);

  const updateCriteria = (field, value) => {
    dispatch(
      actions.updateKeyValueCriteria({
        id,
        value: {
          key: field === 'key' ? value : selectedKey?.value,
          key_condition:
            field === 'key_condition' ? value : selectedKeyCondition?.value,
          value:
            field === 'key'
              ? []
              : map(field === 'value' ? value : selectedValues, o => o?.value),
          value_condition:
            field === 'value_condition' ? value : selectedValueCondition?.value,
        },
      }),
    );
  };

  //load values for selected key
  useEffect(() => {
    selectedKey?.value &&
      dispatch(
        sharedStateActions.getTagValues({ q: { keys: selectedKey?.value } }),
      );
  }, [selectedKey, dispatch]);

  //set value options based on key
  useEffect(() => {
    setValueOptions(
      map(tagValues.data[selectedKey?.value], o => ({ label: o, value: o })),
    );
  }, [selectedKey, tagValues]);

  return (
    <Stack w="full">
      <Stack isInline>
        <Box whiteSpace="nowrap" pt={1}>
          If an entity has tag key
        </Box>
        <Box w={28}>
          <Select
            options={tagQuantifierOptions}
            value={selectedKeyCondition}
            onChange={selected =>
              updateCriteria('key_condition', selected?.value)
            }
          />
        </Box>
        <Box w="full" flex={1}>
          <Select
            options={tagKeyOptions}
            value={selectedKey}
            onChange={selected => updateCriteria('key', selected?.value)}
            isLoading={tagKeys.isLoading}
          />
        </Box>
      </Stack>
      <Stack isInline>
        <Box whiteSpace="nowrap" pt={1}>
          and tag value
        </Box>
        <Box w={28}>
          <Select
            options={tagQuantifierOptions}
            value={selectedValueCondition}
            onChange={selected =>
              updateCriteria('value_condition', selected?.value)
            }
          />
        </Box>
        <Box w="full" flex={1}>
          <Select
            options={valueOptions}
            isMulti
            showTotalSelected={!!selectedValues.length}
            value={selectedValues}
            onChange={selected => updateCriteria('value', selected)}
            isLoading={tagValues.isLoading}
          />
        </Box>
      </Stack>
      <Wrap>
        {map(tagKeyValueCriteria[id]?.value, o => (
          <WrapItem>
            <Tag
              label={o}
              styles={{ label: { whiteSpace: 'pre-wrap' } }}
              closeButton
              onClose={() =>
                updateCriteria(
                  'value',
                  filter(tagKeyValueCriteria[id]?.value, l => l !== o),
                )
              }
            />
          </WrapItem>
        ))}
      </Wrap>
    </Stack>
  );
};
